import React, { useEffect, useState } from 'react';
import { marginService } from './marginService';

export const MarginProtectionDashboard: React.FC = () => {
  const [metrics, setMetrics] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMarginData = async () => {
      try {
        const data = await marginService.getMarginData();
        setMetrics(data);
      } catch (err) {
        console.error('Failed to fetch margin data', err);
      } finally {
        setLoading(false);
      }
    };
    fetchMarginData();
  }, []);

  if (loading) return <div>Loading Margin Data...</div>;

  const getMarginClass = (margin: number) => {
    if (margin < 20) return 'critical';
    if (margin < 40) return 'risk';
    return 'healthy';
  };

  return (
    <div className="module-margin">
      <h3>Margin & AI Cost Protection</h3>
      
      <div className="margin-summary-grid">
        <section className="top-risk">
          <h4>Low Margin Enterprises (&lt; 25%)</h4>
          <table>
            <thead>
              <tr>
                <th>Enterprise</th>
                <th>Margin %</th>
                <th>AI Cost (MTD)</th>
                <th>Revenue (MTD)</th>
              </tr>
            </thead>
            <tbody>
              {metrics.filter(m => m.margin_percent < 25).map(m => (
                <tr key={m.id} className="critical-row">
                  <td>{m.name}</td>
                  <td className={getMarginClass(m.margin_percent)}>
                    {m.margin_percent}%
                  </td>
                  <td>₹{m.ai_cost_mtd}</td>
                  <td>₹{m.revenue_mtd}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        <section className="cost-by-model">
          <h4>AI Model Distribution & Costs</h4>
          <div className="chart-placeholder">Cost per Model distribution Chart</div>
          <div className="downgrade-alerts">
            <h5>Auto-Downgrade Alerts (Last 24h)</h5>
            <div className="alert-item">
              Enterprise A: Downgraded to Eco model (Margin fell to 18%)
            </div>
            <div className="alert-item">
              Enterprise B: Blocked usage (Hard budget limit reached)
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
